<template>
  <div class="department-tab-publications">
    <white-block>
      <content-container class="content-padding pt-40 pb-40">
        <bordered-block>
          <menu-department :id="department.id" :active="route.params?.tab" />
        </bordered-block>
      </content-container>
      <a-spin :spinning="isLoading" />

      <content-container class="content-padding">
        <publications-list :publications="publications" url="intellectual" />
        <div
            class="department-tab-publications-page__pages"
            v-if="total > publications.length"
        >
          <a-pagination
              v-model:current="currentPage"
              v-model:pageSize="pageSize"
              :total="total"
              :show-size-changer="false"
          >
            <template #itemRender="{ type, originalElement }">
              <pagination-arrows
                  :type="type"
                  :original-element="originalElement"
              />
            </template>
          </a-pagination>
        </div>
      </content-container>
    </white-block>
  </div>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useApi } from '@/api/use-api';
import WhiteBlock from '@/views/portal/components/WhiteBlock.vue';
import ContentContainer from '@/views/portal/components/ContentContainer.vue';
import BorderedBlock from '@/views/portal/components/BorderedBlock.vue';
import MenuDepartment from '@/views/portal/components/menus/MenuDepartment.vue';
import PaginationArrows from '@/views/portal/components/UI/PaginationArrows.vue';
import PublicationsList from "@/views/portal/components/publications/PublicationsList.vue";
import {TYPE_INTELLECTUALS} from "@/api/models/Publication";

const isLoading = ref(true);
const api = useApi();
const route = useRoute();
const publications = ref([]);
const sorting = ref('title');
const currentPage = ref(1);
const pageSize = ref(20);
const total = ref(0);

const props = defineProps({
  department: {
    type: Object,
    required: true,
  },
});

const getIntellectuals = async () => {
  if (undefined === props.department.uuid || !props.department.uuid) return;
  try {
    isLoading.value = true;
    const response = await api.publication.index(
        new URLSearchParams({
          page: currentPage.value,
          'per-page': pageSize.value,
          sort: sorting.value,
          organisational_unit_uuid: props.department.uuid,
          type: TYPE_INTELLECTUALS,
        })
    );

    publications.value = response.publications;
    total.value = response.total;
  } catch (error) {
    console.error('error', error);
  } finally {
    isLoading.value = false;
  }
};

onMounted(() => {
  getIntellectuals();
});

watch(
    () => props.department.id,
    () => {
      getIntellectuals();
    }
);

watch(sorting, () => {
  getIntellectuals();
});

watch(currentPage, () => {
  getIntellectuals();
});

watch(pageSize, () => {
  currentPage.value = 1;
  getIntellectuals();
});
</script>

<style lang="scss" scoped>
.publications {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
</style>
